import { render, staticRenderFns } from "./ChannelInfo.html?vue&type=template&id=0db8b548&scoped=true&"
import script from "./ChannelInfo.js?vue&type=script&lang=js&"
export * from "./ChannelInfo.js?vue&type=script&lang=js&"
import style0 from "./ChannelInfo.scss?vue&type=style&index=0&id=0db8b548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8b548",
  null
  
)

export default component.exports